import { useState } from "react";
import "./LeadTabs.css";
import LeadsTable from "./LeadsTable";
import CareerLeadsTable from "./CareerLeadsTable";
import { FiBriefcase, FiUsers } from "react-icons/fi";

const LeadTabs = () => {
  const [activeTab, setActiveTab] = useState("business");

  const tabs = [
    { key: "business", label: "Business Leads", icon: FiUsers },
    { key: "career", label: "Career Leads", icon: FiBriefcase },
  ];

  return (
    <main className="dashboard-page">
      <div className="dashboard-container">
        <header className="dashboard-header">
          <div>
            <p className="dashboard-kicker">Leads</p>
            <h1 className="dashboard-title">Civinex Leads Dashboard</h1>
            <p className="dashboard-subtitle">
              Review contact submissions, career inquiries, notification status, and export filtered lead data.
            </p>
          </div>
        </header>

        <div className="workspace-layout">
          <aside className="workspace-rail">
            <div className="workspace-rail-header">
              <p className="workspace-label">Workspace</p>
              <h2 className="workspace-name">Lead Desk</h2>
            </div>
            <div className="workspace-nav" role="tablist" aria-label="Lead categories">
              {tabs.map((tab) => {
                const Icon = tab.icon;

                return (
                  <button
                    type="button"
                    key={tab.key}
                    className={`workspace-nav-item ${activeTab === tab.key ? "active" : ""}`}
                    onClick={() => setActiveTab(tab.key)}
                    role="tab"
                    aria-selected={activeTab === tab.key}
                  >
                    <Icon aria-hidden="true" />
                    <span>{tab.label}</span>
                  </button>
                );
              })}
            </div>
            <div className="workspace-insight">
              Switch between business contacts and hiring inquiries without leaving the lead workspace.
            </div>
          </aside>

          <section className="workspace-content dashboard-panel dashboard-tabs-panel">
            <div className="dashboard-tab-content">
              {activeTab === "business" && <LeadsTable />}
              {activeTab === "career" && <CareerLeadsTable />}
            </div>
          </section>
        </div>
      </div>
    </main>
  );
};

export default LeadTabs;
